import { getStateStore } from '../../stores';

const state = getStateStore('ipc');

export const initializeInvitationSendEvents = () => {
  console.log('InvitationSendEvents initialized');
  let cachedInvitationSendState = state.invitationSendState.currentState;
  let emailExpiryTimeout: NodeJS.Timeout;
  let smsExpiryTimeout: NodeJS.Timeout;
  state.invitationSendState.addListener((invitationSendState) => {
    console.log('[InvitationSendEvents] invitationSendState changed');

    if (invitationSendState.emailLimitExpiry !== cachedInvitationSendState.emailLimitExpiry) {
      console.log('[InvitationSendEvents] invitationSendState emailLimit expiry changed');
      const timeToExpire = invitationSendState.emailLimitExpiry - Date.now();

      console.log('timeToExpire', timeToExpire);
      if (timeToExpire > 0) {
        if (emailExpiryTimeout) clearTimeout(emailExpiryTimeout);

        emailExpiryTimeout = setTimeout(() => {
          state.invitationSendState.updateState({
            ...state.invitationSendState.currentState,
            emailLimitExpiry: 0,
            emailCount: 0,
            reachedEmailInviteLimit: false,
          });
        }, timeToExpire);
      }
    }

    if (invitationSendState.smsLimitExpiry !== cachedInvitationSendState.smsLimitExpiry) {
      console.log('[InvitationSendEvents] invitationSendState smsLimit expiry changed');
      const timeToExpire = invitationSendState.smsLimitExpiry - Date.now();

      if (timeToExpire > 0) {
        if (smsExpiryTimeout) clearTimeout(smsExpiryTimeout);
        smsExpiryTimeout = setTimeout(() => {
          state.invitationSendState.updateState({
            ...state.invitationSendState.currentState,
            smsLimitExpiry: 0,
            smsCount: 0,
            reachedSmsInviteLimit: false,
          });
        }, timeToExpire);
      }
    }

    cachedInvitationSendState = { ...invitationSendState };
  });
};
